import React, { useEffect, useState } from "react";
import moment from "moment";
import { FaEye } from "react-icons/fa";
import { ThreeDots } from "react-loader-spinner";
import { toast } from "react-toastify";
import DashBoardSidebar from "../../layouts/dashBoard-Sidebar";
import DashboardNavbar from "../../layouts/dashboardNavbar";
import PaginatedItems from "./pagination";
import { getGladeInvoiceHistory, updateGladeInvoice } from "../../api/server";
import BillingSourceTabs from "./BillingSourceTabs";
import BillingFilterDropdown from "./BillingFilterDropdown";
import "./BillingWorkspace.css";

const GladeInvoiceHistory = () => {
  const [response, setResponse] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [total, setTotal] = useState(0);
  const [course, setCourse] = useState("all");
  const [status, setStatus] = useState("unpaid");
  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);

  const fetchData = async (page = pageNo, selectedCourse = course, selectedStatus = status) => {
    setLoading(true);
    try {
      const result = await getGladeInvoiceHistory(page, selectedCourse, selectedStatus);
      setResponse(result?.data?.data || []);
      setTotal(result?.data?.total || 0);
    } catch (error) {
      toast.error(error?.response?.data?.error || "Failed to fetch Glade invoice history");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(1, course, status);
    setPageNo(1);
    setSelectedIds([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [course, status]);

  const handlePageChange = (page) => {
    setPageNo(page);
    setSelectedIds([]);
    fetchData(page, course, status);
  };

  const updatePaidStatus = async () => {
    setUpdating(true);
    try {
      const result = await updateGladeInvoice({ ids: selectedIds });
      toast.success(result?.data?.message || "Paid status updated successfully.");
      setSelectedIds([]);
      await fetchData(pageNo, course, status);
    } catch (error) {
      toast.error(error?.response?.data?.error || "Update failed");
    } finally {
      setUpdating(false);
    }
  };

  return (
    <div className="wrapper">
      <DashBoardSidebar />
      <div id="content">
        <DashboardNavbar />
        <section className="manage-students language_wrap billing-workspace">
          <BillingSourceTabs activeSource="glade" view="history" />
          <div className="invoice-history-toolbar">
            <div className="invoice-history-controls">
              <BillingFilterDropdown
                id="glade-history-course-filter"
                label="Course"
                icon="fa-solid fa-graduation-cap"
                value={course}
                onChange={setCourse}
                options={[
                  { value: "all", label: "All" },
                  { value: "first", label: "CC" },
                  { value: "second", label: "DE" },
                ]}
              />
              <BillingFilterDropdown
                id="glade-history-status-filter"
                label="Payment Status"
                icon="fa-solid fa-circle-check"
                value={status}
                onChange={setStatus}
                options={[
                  { value: "unpaid", label: "Not paid" },
                  { value: "paid", label: "Paid" },
                ]}
              />
            </div>
          </div>

          <div className="billing-list-card">
            <div className="billing-list-table-scroll">
              <table className="table glade-billing-table billing-list-table">
                <thead>
                  <tr>
                    <th>Course</th>
                    <th>Month</th>
                    <th>Amount</th>
                    <th>Invoice</th>
                    <th>Created At</th>
                    <th>Paid</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr><td colSpan={6}><ThreeDots height="40" width="80" color="#4fa94d" wrapperStyle={{ display: "flex", justifyContent: "center" }} /></td></tr>
                  ) : response.length > 0 ? response.map((invoice, index) => (
                    <tr key={invoice.id}>
                      <td>{invoice.course}</td>
                      <td>{invoice.month || "-"}</td>
                      <td>{invoice.amount}</td>
                      <td>
                        <a href={invoice.link} target="_blank" rel="noreferrer">
                          <FaEye style={{ color: "black" }} />
                        </a>
                      </td>
                      <td>{moment(invoice.created_at).format("MMMM Do YYYY")}</td>
                      <td>
                        <div className="iagree_radio">
                          <input
                            type="checkbox"
                            id={`gladeInvoice${index}`}
                            checked={invoice.paid === "checked" || selectedIds.includes(invoice.id)}
                            disabled={invoice.paid === "checked"}
                            onChange={(event) => setSelectedIds((current) =>
                              event.target.checked
                                ? [invoice.id, ...current]
                                : current.filter((id) => id !== invoice.id)
                            )}
                          />
                          <label htmlFor={`gladeInvoice${index}`} className="text-white">B</label>
                        </div>
                      </td>
                    </tr>
                  )) : (
                    <tr><td colSpan={6}>No Glade invoices found</td></tr>
                  )}
                </tbody>
              </table>

              {response.length > 0 && status === "unpaid" && (
                <div className="text-center">
                  <button className="btn_brnd mt-4" disabled={updating || selectedIds.length === 0} onClick={updatePaidStatus}>
                    {updating ? <ThreeDots height="20" width="60" color="#4fa94d" /> : "Update"}
                  </button>
                </div>
              )}
              {!loading && total > 10 && (
                <PaginatedItems
                  pageSize={10}
                  total={total}
                  pageNo={pageNo}
                  setPageNo={setPageNo}
                  handlePageChange={handlePageChange}
                />
              )}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default GladeInvoiceHistory;
